module.exports = "https://r.zoocdn.com/_next/static/images/hero-1000-714172b2147698d077a9ff4d6b3e9726.jpg";